import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
    PContainer,
    PSection,
    PBox,
    PH1,
    PText,
    PH3,
    PImg,
} from "../../theme/BaseTheme";

export const AIFilters = () => {
    return (
        <PSection css={styles}>
            <PBox className="landing-tools">
                <PBox className="landing-tools-container">
                    <PText className="landing-tools-subtitle">
                        AI Image Filters
                    </PText>
                    <PH1 className="landing-tools-title">
                        Explore More AI Image Filters
                    </PH1>

                    <PBox className="landing-tools-wrapper">
                        <Link to="/ai-comic-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/comic-filter-cover.webp"
                                    alt="AI Comic Filter"
                                />
                                <PText>AI Comic Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-ghibli-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/ghibli-filter-cover.webp"
                                    alt="AI Ghibli Filter"
                                />
                                <PText>AI Ghibli Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-manga-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/manga-filter-cover.webp"
                                    alt="AI Manga Filter"
                                />
                                <PText>AI Manga Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-oil-painting-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/oil-painting-filter-cover.webp"
                                    alt="AI Oil Painting Filter"
                                />
                                <PText>AI Oil Painting Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-pixel-art-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/pixel-art-filter-cover.webp"
                                    alt="AI Pixel Art Filter"
                                />
                                <PText>AI Pixel Art Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-rick-and-morty-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/rick-and-morty-filter-cover.webp"
                                    alt="AI Rick And Morty Filter"
                                />
                                <PText>AI Rick And Morty Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-rococo-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/rococo-filter-cover.webp"
                                    alt="AI Rococo Filter"
                                />
                                <PText>AI Rococo Filter</PText>
                            </PBox>
                        </Link>
                        <Link to="/ai-simpson-filter">
                            <PBox className="landing-tools-item">
                                <PImg
                                    src="/images/image-filters/simpson-filter-cover.webp"
                                    alt="AI Simpson Filter"
                                />
                                <PText>AI Simpson Filter</PText>
                            </PBox>
                        </Link>
                    </PBox>
                </PBox>
            </PBox>
        </PSection>
    );
};

const styles = {
    //backgroundColor: "rgb(238, 236, 255)",
    fontFamily:
        "Inter var, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    "& .landing-tools": {
        //padding: "4rem 1.5rem 1rem 1.5rem",
        maxWidth: "64rem",
        margin: "0 auto",
        paddingBottom: "2rem",
        "@bp2": { marginTop: "2rem" },
        "@bp4": { paddingLeft: "4rem", paddingRight: "4rem" },
    },
    "& .landing-tools-container": {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
    "& .landing-tools-subtitle": {
        color: "$colors$primary",
        lineHeight: "1.75rem",
        fontWeight: "600",
        fontSize: "1rem",
        textAlign: "center",
    },
    "& .landing-tools-title": {
        color: "rgb(17 24 39)",
        fontWeight: "700",
        fontSize: "1.875rem",
        lineHeight: "2.5rem",
        marginTop: "0.5rem",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        "@bp2": { fontSize: "2.25rem", lineHeight: "3rem" },
    },
    "& .landing-tools-wrapper": {
        position: "relative",
        paddingLeft: "3rem",
        paddingRight: "3rem",
        maxWidth: "80rem",
        marginTop: "3rem",
        marginBottom: "5rem",
        marginLeft: "auto",
        marginRight: "auto",
        overflow: "hidden",
        display: "grid",
        maxWidth: "20rem",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gap: "2.5rem",
        "@bp2": {
            maxWidth: "48rem",
            paddingLeft: "4rem",
            paddingRight: "4rem",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: "3rem",
        },
        "@bp4": {
            maxWidth: "none",
            paddingLeft: "0",
            paddingRight: "0",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "4rem",
            marginBottom: "6rem",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: "1rem",
        },
    },
    "& .landing-tools-item": {
        position: "relative",
        borderRadius: "0.75rem",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
        "&:hover": {
            transform: "translateY(-4px)",
            "& video": {
                transform: "scale(1.05)",
            },
            "& img": {
                transform: "scale(1.05)",
            },
        },
        "& video": {
            width: "100%",
            aspectRatio: "1/1",
            borderRadius: "0.75rem",
            transition: "transform 0.2s ease-in-out",
        },
        "& img": {
            width: "100%",
            aspectRatio: "1/1",
            borderRadius: "0.75rem",
            transition: "transform 0.2s ease-in-out",
        },
        "& p": {
            textAlign: "center",
            margin: "0",
            marginTop: "0.75rem",
            marginBottom: "1.5rem",
            width: "100%",
            color: "rgb(17 24 39)",
            fontWeight: "600",
            fontSize: "1.125rem",
            lineHeight: "1.5",
        },
    },
    "& a": {
        textDecoration: "none",
        display: "block",
        "&:hover": {
            color: "$colors$primary",
        },
    },
};
